import { type ComponentProps } from 'react'

import Svg from '~/shared/assets/Svg'

interface Props extends ComponentProps<typeof Svg> {}

const Lines = ({ ...rest }: Props) => {
  return (
    <Svg
      width={364}
      height={264}
      viewBox="0 0 364 264"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...rest}
    >
      <path
        d="M4 184.374L216.972 4"
        stroke="url(#paint0_linear_330_45611)"
        strokeWidth="7"
        strokeLinecap="round"
      />
      <path
        d="M130.729 260.437L343.701 78.9766"
        stroke="url(#paint1_linear_330_45611)"
        strokeWidth="7"
        strokeLinecap="round"
      />
      <path
        d="M147.028 202.848L360 21.3867"
        stroke="url(#paint2_linear_330_45611)"
        strokeWidth="7"
        strokeLinecap="round"
      />
      <defs>
        <linearGradient
          id="paint0_linear_330_45611"
          x1="110.486"
          y1="4"
          x2="110.486"
          y2="184.374"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#F0F0F0" />
          <stop offset="1" stopColor="#C1C3C2" />
        </linearGradient>
        <linearGradient
          id="paint1_linear_330_45611"
          x1="237.215"
          y1="78.9766"
          x2="237.215"
          y2="260.437"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#F0F0F0" />
          <stop offset="1" stopColor="#C1C3C2" />
        </linearGradient>
        <linearGradient
          id="paint2_linear_330_45611"
          x1="253.514"
          y1="21.3867"
          x2="253.514"
          y2="202.848"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#F0F0F0" />
          <stop offset="1" stopColor="#C1C3C2" />
        </linearGradient>
      </defs>
    </Svg>
  )
}

export default Lines
